import waybill from './waybill';
import invoiceApplicationCount from './invoiceApplicationCount';
import vehicleNotCarried from './vehicleNotCarried';
import youRanStatisticalReport from './youRanStatisticalReport';
import discounts from './discounts'
import youranInquiryStatistics from './youranInquiryStatistics'
export default [...waybill, ...invoiceApplicationCount, ...vehicleNotCarried, ...youRanStatisticalReport, ...discounts, ...youranInquiryStatistics]
